module.exports = __webpack_public_path__ + "static/media/bubble.8a8f8bb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bubble.svg
// module id = 863
// module chunks = 0